<template>
  <div>
    <div class="nk-app-root">
      <div class="nk-main">
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block nk-block-lg">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h4 class="nk-block-title">{{ $t('dm_preislisten_title') }}</h4>
                        </div>
                      </div>

                      <!-- No preisliste yet -->
                      <div v-if="loaded && !redirecting" class="text-center py-5">
                        <em class="icon ni ni-file-text" style="font-size: 48px; color: #c4cdd5;"></em>
                        <p class="text-muted mt-3 mb-4">{{ $t('dm_preislisten_empty') }}</p>
                        <div v-if="canDmEdit">
                          <button class="btn btn-primary" @click="$refs.importFile.click()">
                            <em class="icon ni ni-upload"></em> {{ $t('dm_preislisten_btn_import') }}
                          </button>
                          <input type="file" ref="importFile" accept=".xlsm,.xlsx" style="display:none" @change="onImportFile" />
                        </div>
                      </div>

                    </div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Navigation from "../../../components/Navigation.vue";
import Footer from "../../../components/Footer.vue";
import dmTableMixin from "@/mixins/dm-table-mixin";
import dmPermissionsMixin from "@/mixins/dm-permissions-mixin";
import { getPreislisteList, importPreisliste } from "@/services/dm.service";

export default {
  name: "DmPreislisten",
  components: { Header, Navigation, Footer },
  mixins: [dmTableMixin, dmPermissionsMixin],
  data() {
    return {
      loaded: false,
      redirecting: false,
    };
  },
  computed: {
    loading_page() {
      return this.$store.state.loading_page && this.$store.state.loading_page == "setup";
    },
  },
  created() {
    this.loadAndRedirect();
  },
  methods: {
    loadAndRedirect() {
      this.showLoader();
      getPreislisteList()
        .then((d) => {
          this.hideLoader();
          var list = (d.data && d.data.list) || [];
          if (list.length > 0) {
            // Active preisliste exists — redirect to detail
            this.redirecting = true;
            this.$router.replace("/dm/preisliste/" + list[0]._id);
          } else {
            this.loaded = true;
          }
        })
        .catch((e) => {
          this.hideLoader();
          this.loaded = true;
          this.$store.dispatch("api_error", e);
        });
    },
    onImportFile(evt) {
      var file = evt.target.files && evt.target.files[0];
      if (!file) return;
      this.$refs.importFile.value = "";
      this.showLoader();
      importPreisliste(file)
        .then((d) => {
          this.hideLoader();
          if (d && d.status === "error") {
            this.$swal({ title: this.$t('dm_preislisten_import_error'), text: d.message, icon: "error" });
            return;
          }
          var preisliste = (d && d.data && d.data.preisliste) || {};
          var summary = (d && d.data && d.data.summary) || {};
          var lines = [];
          if (summary.berechnung) lines.push(this.$t('dm_pl_tab_berechnung') + ": " + summary.berechnung);
          if (summary.anlagendaten) lines.push(this.$t('dm_pl_tab_anlagendaten') + ": " + summary.anlagendaten);
          if (summary.einzelpreise) lines.push(this.$t('dm_pl_tab_einzelpreise') + ": " + summary.einzelpreise);
          var self = this;
          this.$swal({
            title: this.$t('dm_preislisten_import_success'),
            html: lines.length ? lines.join("<br>") : "",
            icon: "success",
          }).then(function() {
            if (preisliste._id) {
              self.$router.push("/dm/preisliste/" + preisliste._id);
            }
          });
        })
        .catch((e) => {
          this.hideLoader();
          this.$swal({ title: this.$t('dm_preislisten_import_error'), text: e.message || "Import fehlgeschlagen", icon: "error" });
        });
    },
  },
};
</script>
